/**
 * Narrows an unvalidated string (a search param, a select value) to a member of
 * a generated string enum, or undefined when it isn't one — so an unknown value
 * is dropped rather than cast through and sent to the API.
 */
export function enumValue<T extends Record<string, string>>(
  enumObject: T,
  value: string | undefined,
): T[keyof T] | undefined {
  if (value === undefined) return undefined;
  const members: readonly string[] = Object.values(enumObject);
  if (!members.includes(value)) return undefined;
  return value as T[keyof T];
}
